<template>
    <v-layout row wrap>
      <v-flex xs10 offset-1>
        <v-card outlined color = "lightgray">
            <v-card-title >
                Leaderboard
            </v-card-title>
          <v-card-text>
              <v-layout row wrap style="font-weight: bold;">
                <v-flex xs1 offset-1> 
                  position
                </v-flex>
                <v-flex xs2> 
                  nickname
                </v-flex>
                <v-flex xs1> 
                  xp
                </v-flex>
                <v-flex xs2> 
                  country
                </v-flex>
                <v-flex xs1> 
                  level
                </v-flex>
                <v-flex xs2> 
                  groups
                </v-flex>
              </v-layout>
              <v-layout row wrap v-for="(leader, index) in leaderList" :key="index"> 
                <v-flex xs1 offset-1> 
                  {{index+1}}.
                </v-flex>
                <v-flex xs2> 
                  {{leader.nickname}}
                </v-flex>
                <v-flex xs1> 
                  {{leader.xp}}
                </v-flex>
                <v-flex xs2> 
                  {{leader.country}}
                </v-flex>
                <v-flex xs1> 
                  {{leader.level_id}}
                </v-flex>
                <v-flex xs2> 
                  {{leader.groups}}                  
                </v-flex>
              </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
  </v-layout>
</template>

<script>
import axios from '../../axios-auth.js'

  export default {
    data() {
      return {
        leaderList: null,
      }
    },
    mounted () {
      this.initData()
   },
   methods: {
    initData() {
      this.$store.commit('setBcChange',true)
     // this.$router.push({name:'dashboard'})   
      this.getMyLeaders()
    },
    getMyLeaders() {
      axios.get('/get-leaders', this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            this.leaderList = res.data.list
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
   }
  }
</script>

<style>

</style>